import { injectable, inject } from 'inversify';
import { HelpDeskSymbols } from './symbols';
import IHelpDeskService from './i-helpdesk-service';
import IHelpDeskProvider from './i-helpdesk-provider';
import { ActionResult, ErrorTypes } from '../Common';
import { Order } from './order-info';
import { Ticket } from './ticket-data';
import { RefundRequest } from './refund-request';

@injectable()
export default class DefaultHelpDeskService implements IHelpDeskService {
    private _provider: IHelpDeskProvider;

    constructor(@inject(HelpDeskSymbols.HelpDeskProvider) helpdeskProvider: IHelpDeskProvider) {
        this._provider = helpdeskProvider;
    }

    async FindByPaymentCodeAsync(code: string, email: string, phone: string): Promise<ActionResult<Order>> {
        return this._provider.FindByPaymentCodeAsync(code, email, phone);
    }

    async FindByIdAsync(orderId: string, email: string, phone: string): Promise<ActionResult<Order>> {
        return this._provider.FindByIdAsync(orderId, email, phone);
    };

    async FindByCodeAsync(orderCode: number, email: string, phone: string): Promise<ActionResult<Order>> {
        return this._provider.FindByCodeAsync(orderCode, email, phone);
    };

    async FindByLinkParametersAsync(sign: string, orderId: number, email: string, phone: string): Promise<ActionResult<Order>> {
        return this._provider.FindByLinkParametersAsync(sign, orderId, email, phone);
    };

    async GetTicketDataAsync(orderId: number, orderItemId: number, access_token: string): Promise<ActionResult<Ticket>> {
        return this._provider.GetTicketDataAsync(orderId, orderItemId, access_token);
    };

    // http://redmine.isd.su/issues/8412
    async RequestRefundAsync(refund: any): Promise<ActionResult> {
        return this._provider.RequestRefundAsync(refund);
    };
    async ApproveRefundAsync(order: Order): Promise<ActionResult> {
        return this._provider.ApproveRefundAsync(order);
    };
    async DeclineRefundAsync(order: Order): Promise<ActionResult> {
        return this._provider.DeclineRefundAsync(order);
    };
    async GetRefundsAsync(status: number, page?: number, pageCount?: number): Promise<ActionResult<Array<RefundRequest>>> {
        return this._provider.GetRefundsAsync(status, page, pageCount);
    };
};